import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import GHref from 'tennders-market/common/components/element/GHref'
import GRoute from 'tennders-common/form/components/GRoute'
import IconAddFilled from '../../../../icons/icon-add-filled.svg'

const DeliveryLocation = (props) => {
  const { t } = useTranslation()
  const {
    form,
    errors,
    onChange,
    getMinDeliveryRouteDate,
    deliveryStops,
    removeDeliveryStop,
    getMinDeliveryDate,
    setDeliveryStops,
    addDeliveryStop
  } = props

  return (
    <>
      <h3 className="bold">{t('document:delivery')}</h3>
      <GRoute
        forDocument
        orderGenerateDoc
        isDelivery
        title={`1. ${t('document:deliveryLocation')}`}
        errors={errors && errors.deliveryRoute}
        minDate={getMinDeliveryRouteDate()}
        route={form.deliveryRoute}
        isAllRequired
        onChange={(location, childKey) => onChange('deliveryRoute', location, childKey)}
      />
      {deliveryStops.map((location, index) => (
        <GRoute
          forDocument
          orderGenerateDoc
          isDelivery
          errors={errors[`deliveryStops[${index}]`]}
          removeStop={removeDeliveryStop}
          hasRemoveStop
          title={`${index + 2}. ${t('document:deliveryLocation')}`}
          minDate={getMinDeliveryDate(index)}
          key={location.identifier}
          route={deliveryStops[index]}
          onChange={(location) => {
            const stops = [...deliveryStops]
            stops[index] = { ...location }
            setDeliveryStops(stops)
          }}
        />
      ))}
      <GHref className="d-flex align-center mt-16 mr-32 btn-link" onClick={addDeliveryStop}>
        <IconAddFilled className="btn-only-icon" />
        {t('document:addAnotherDeliveryStop')}
      </GHref>
    </>
  )
}

export default React.memo(DeliveryLocation)
